import React from "react";
import "./RentalAgreement.css";
import { Link } from "react-router-dom";
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { AiOutlineDoubleRight } from "react-icons/ai";
const RentalAgreement = () => {
  return (
    <>
      <div class="tf-page-title">
        <div class="row">
          <div class="col-12">
            <div class="heading text-center ">
              <h4 className='breadcrumbtitle'>RentalAgreement</h4>
              <div className=' breadcrumb'>
                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                <h6>RentalAgreement</h6></div>
            </div>
          </div>
        </div>
      </div>
      <div className="rental-agreement-container " >

        <p className="rental-agreement-intro">
          This Rental Agreement ("Agreement") is made between RoyalHood
          ("Lessor") and the individual or entity renting the items ("Lessee"). By
          completing the rental process, the Lessee agrees to abide by the terms
          set forth herein.
        </p>

        <ol className="rental-agreement-list">
          <li>
            <strong>Rental Items:</strong>
            <p>The Lessor agrees to rent the items selected by the Lessee as detailed in the order confirmation.</p>
          </li>
          <li>
            <strong>Rental Period:</strong>
            <p>The rental period begins on the date the item is received by the Lessee and ends on the specified return date.</p>
          </li>
          <li>
            <strong>Customer Obligations:</strong>
            <ul>
              <li>Care and maintenance of the rented items.</li>
              <li>Returning items in their original condition, free from damage or excessive wear.</li>
              <li>Promptly notifying the Lessor of any issues with the items upon receipt.</li>
            </ul>
          </li>
          <li>
            <strong>Return Conditions:</strong>
            <ul>
              <li>Items must be returned in their original condition, including all tags and packaging.</li>
              <li>The Lessee is responsible for securely packaging items for return to prevent damage.</li>
            </ul>
          </li>
          <li>
            <strong>Damage Fees:</strong>
            <ul>
              {/* <li>Minor damage: $50 per dress</li>
            <li>Moderate damage: $75 per dress</li> */}
              <li>Major damage/replacement: Full cost of the dress</li>
            </ul>
          </li>
          <li>
            <strong>Late Return Policy:</strong>
            <p>Items must be returned by the specified due date.</p>
            {/* A late fee of $25 per day will be charged for overdue items. */}
          </li>
          <li>
            <strong>Payment Terms:</strong>
            <ul>
              <li>All rental fees and applicable charges must be paid in full at the time of order confirmation.</li>
              <li>Refunds will be processed using the original payment method.</li>
            </ul>
          </li>
          <li>
            <strong>Strict Cancellation Policy:</strong>
            <ul>
              <li>
                <strong>Non-refundable items:</strong> Specify which items (Our Clearance items are final sales and it is AS IS) are non-refundable.
              </li>
              <li>
                <strong>Return eligibility:</strong> Returns will only be accepted if the item is in its original condition and packaging.
              </li>
              <li>
                <strong>Return Window:</strong> If there is a sizing or quality issue, customers must inform RoyalHood’s customer service at <a href="mailto:support@royalhood.in">support@royalhood.in</a> as soon as the item is received. To be eligible for a full refund, the item must be returned within 24 hours of delivery.
              </li>
              <li>
                <strong>Refund Method:</strong> Refunds will be processed using the same payment method used for the original transaction.
              </li>
            </ul>
          </li>
          <li>
            <strong>Acknowledgment of Terms:</strong>
            <p>
              By checking the box at checkout, the Lessee acknowledges that they have read and understood the terms of this rental agreement and agree to be bound by them.
            </p>
          </li>
          <li>
            <strong>Contact Information:</strong>
            <p>
              For any inquiries regarding this rental agreement, please contact RoyalHood customer service at <a href="mailto:support@royalhood.in">support@royalhood.in</a>.
            </p>
          </li>
        </ol>
      </div>
      <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        {/* <div class="toolbar-item">
            <a style={{color:"black"}} href="#" >
                <div class="toolbar-icon">
                <MdOutlineAccountCircle />
                </div>
                <div class="toolbar-label">Account</div>
            </a>
        </div> */}

        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
    </>
  )
}
export default RentalAgreement